import * as React from "react"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import TextField from "@mui/material/TextField"
import CloseIcon from '@mui/icons-material/Close';
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import { AXIOS_API_INSTANCE } from "../../../Constants"
import { send_authorized_request } from "../../../Constants/cognito"
import { useSnackbar } from 'notistack';
import { Autocomplete, Box, Checkbox, FormControlLabel, IconButton } from "@mui/material"
import Grid from "@mui/material/Grid2"
import { LoadingBackdropIndeterminate } from "../../LoadingBackdrop"
import { useServiceKits } from "../../ReactQuery/QueryServiceKits"
import { formatDuration, moneyFormat } from "../../../Utils"

export default function AddServiceOrderServiceModal({
    serviceOrder,
    open,
    closeModal,
    newServiceOrder = false,
}) {
    const { enqueueSnackbar } = useSnackbar();
    const { data: serviceKits, isSuccess: serviceKitsLoaded } = useServiceKits();
    const [serviceKit, setServiceKit] = React.useState(undefined)
    const [name, setName] = React.useState("")
    const [preapproved, setPreapproved] = React.useState(false)
    const [notes, setNotes] = React.useState("")
    const [saving, setSaving] = React.useState(false)

    // const getServiceKits = () => {
    //     send_authorized_request(() =>
    //         AXIOS_API_INSTANCE.get(`servicekits`).then((servicekits) => {
    //             setServiceKits(servicekits.data.data.filter((serviceKit) => {
    //                 if (serviceKit.has_active_times) {
    //                     if (dayjs.utc(serviceKit.start_active_time) > dayjs.utc() || dayjs.utc(serviceKit.end_active_time) < dayjs.utc()) {
    //                         if (serviceKit.recurring_active_time) {
    //                             let start = dayjs.utc(serviceKit.start_active_time).add(1, 'year')
    //                             let end = dayjs.utc(serviceKit.end_active_time).add(1, 'year')
    //                             while (start < dayjs.utc()) {
    //                                 if (start < dayjs.utc() && dayjs.utc() < end) {
    //                                     return true
    //                                 }
    //                                 start = start.add(1, 'year')
    //                                 end = end.add(1, 'year')
    //                             }
    //                         }
    //                         return false
    //                     }
    //                 }
    //                 return true
    //             }))
    //         }).catch((error) => {
    //             console.log(error);
    //             enqueueSnackbar(`Failed to load servicekits: ${error.response?.data?.message ?? "Unknown Error Occurred"}`, { variant: 'error' })
    //         }))
    // }

    const save = (event) => {
        const new_service = {
            servicekit_id: serviceKit.id,
            name: name,
            preapproved: preapproved,
            notes: notes.trim()
        }
        if (newServiceOrder) {
            closeModal(new_service)
        } else {
            setSaving(true)
            send_authorized_request(() =>
                AXIOS_API_INSTANCE.post(`serviceorders/${serviceOrder.id}/add_service`, new_service).then((serviceOrder) => {
                    setSaving(false)
                    enqueueSnackbar('Successfully added service', { variant: 'success' })
                    closeModal(serviceOrder.data.data)
                }).catch((error) => {
                    setSaving(false)
                    enqueueSnackbar(`Failed to add service <${error.response?.data?.message ?? "Unknown Error Occurred"}>`, { variant: 'error' })
                })
            )
        }
    }

    React.useEffect(() => {
        if (open) {
        }else{
            setServiceKit(undefined)
            setName("")
            setPreapproved(false)
            setNotes("")
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open])

    return (
        (<div>
            <Dialog
                open={open}
                onClose={() => closeModal(false)}
                maxWidth={'md'}
                fullWidth
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <LoadingBackdropIndeterminate
                    open={saving}
                    text={"Adding Service"}
                />
                <DialogTitle>
                    <span style={{ "paddingRight": "24px" }}>Adding Service</span>
                    <IconButton
                        aria-label="close"
                        onClick={() => closeModal(false)}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Box>
                        <Grid container spacing={2} sx={{ minWidth: '300px' }} columns={{ xs: 6, sm: 12 }}>
                            <Grid sx={{ mt: 1 }} size={12}>
                                <Autocomplete
                                    getOptionLabel={(option) => `${option?.name || ""}`}
                                    options={serviceKits.sort((a, b) => a.name.localeCompare(b.name, "en", { sensitivity: "base" })) ?? []}
                                    autoComplete
                                    includeInputInList
                                    filterSelectedOptions
                                    value={serviceKit}
                                    noOptionsText="No Service Kits"
                                    loading={!serviceKitsLoaded}
                                    onChange={(event, newValue) => {
                                        setServiceKit(newValue)
                                        setName(newValue?.name || "")
                                    }}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Select a service kit" fullWidth />
                                    )}
                                    renderOption={(props, option, { inputValue }) => {
                                        const matches = match(props.key, inputValue, { insideWords: true, findAllOccurrences: true });
                                        const parts = parse(props.key, matches);
                                        props.key = props.id

                                        return (
                                            <li {...props}>
                                                <div>
                                                    {parts.map((part, index) => (
                                                        <span
                                                            key={index}
                                                            style={{
                                                                fontWeight: part.highlight ? 700 : 400,
                                                            }}
                                                        >
                                                            {part.text}
                                                        </span>
                                                    ))}
                                                </div>
                                            </li>
                                        );
                                    }}
                                />
                            </Grid>
                            <Grid size={12}>
                                <span>{serviceKit?.description}</span>
                            </Grid>
                            <Grid container size={6}>
                                <Grid size={12}>
                                    <TextField
                                        margin="dense"
                                        id="name"
                                        label="Service Name (Customer Visible)"
                                        type="text"
                                        fullWidth
                                        variant="filled"
                                        value={name}
                                        onChange={(e) => setName(e.target.value)}
                                    />
                                </Grid>
                                <Grid size={12}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={preapproved}
                                                onChange={(e) => setPreapproved(e.target.checked)}
                                            />
                                        }
                                        label="Preapproved by customer"
                                    />
                                </Grid>
                            </Grid>
                            <Grid size={6}>
                                <h3 style={{ textAlign: 'center' }}>Default Pricing</h3>
                                <Grid container spacing={3}>
                                    <Grid container direction="column" sx={{ textAlign: 'right' }} size={6}>
                                        <Grid>
                                            <span>Flat Rate Cost</span>
                                        </Grid>
                                        <Grid>
                                            <span>Hourly Rate</span>
                                        </Grid>
                                        <Grid>
                                            <span>Part Costs</span>
                                        </Grid>
                                    </Grid>
                                    <Grid container direction="column" sx={{ textAlign: 'right' }} size={6}>
                                        <Grid>
                                            <span>${moneyFormat(serviceKit?.default_flat_rate)}</span>
                                        </Grid>
                                        <Grid>
                                            <span>{formatDuration(serviceKit?.default_minutes_worked)} hrs @ ${moneyFormat(serviceKit?.hourly_rate)} / hr</span>
                                        </Grid>
                                        <Grid>
                                            <span>{serviceKit?.part_price_adjustment === -100 ?
                                                "$0 (INCLUDED)"
                                                :
                                                serviceKit?.part_price_adjustment === 0 ?
                                                    `At Cost`
                                                    :
                                                    `${serviceKit?.part_price_adjustment > 0 ? '+' : ''}${serviceKit?.part_price_adjustment ?? 0}%`
                                            }</span>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid size={12}>
                                <TextField
                                    margin="dense"
                                    id="addservicenote"
                                    label="Notes (optional)"
                                    type="text"
                                    fullWidth
                                    variant="filled"
                                    multiline
                                    minRows={2}
                                    value={notes}
                                    onChange={(event) => setNotes(event.target.value)}
                                    sx={{ mt: 0 }}
                                    slotProps={{
                                        input: { maxLength: 2055 }
                                    }}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Grid container justifyContent="space-between" sx={{ padding: "0px 30px 10px 30px", width: '100%' }}>
                        <Grid size="auto">
                        </Grid>
                        <Grid size="auto">
                            <Button variant="contained" autoFocus onClick={save} disabled={serviceKit === undefined || name === ""}>
                                Add
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </div>)
    );
}
